var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageThumbnailSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1448_1623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5107 36.875C39.5107 38.9636 38.6811 40.9666 37.2042 42.4435C35.7274 43.9203 33.7243 44.75 31.6357 44.75C29.5472 44.75 27.5441 43.9203 26.0673 42.4435C24.5904 40.9666 23.7607 38.9636 23.7607 36.875C23.7607 34.7864 24.5904 32.7834 26.0673 31.3065C27.5441 29.8297 29.5472 29 31.6357 29C33.7243 29 35.7274 29.8297 37.2042 31.3065C38.6811 32.7834 39.5107 34.7864 39.5107 36.875Z",
    fill: "#1A75E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5107 13.25C15.726 13.25 13.0553 14.3562 11.0861 16.3254C9.11699 18.2945 8.01074 20.9652 8.01074 23.75V76.25C8.01074 79.0348 9.11699 81.7055 11.0861 83.6746C13.0553 85.6438 15.726 86.75 18.5107 86.75H81.5107C84.2955 86.75 86.9662 85.6438 88.9354 83.6746C90.9045 81.7055 92.0107 79.0348 92.0107 76.25V23.75C92.0107 20.9652 90.9045 18.2945 88.9354 16.3254C86.9662 14.3562 84.2955 13.25 81.5107 13.25H18.5107ZM81.5107 18.5C82.9031 18.5 84.2385 19.0531 85.2231 20.0377C86.2076 21.0223 86.7607 22.3576 86.7607 23.75V57.875L66.9315 47.6533C66.4392 47.4066 65.8817 47.3211 65.3381 47.4087C64.7945 47.4963 64.2922 47.7527 63.9022 48.1415L44.4247 67.619L30.4597 58.316C29.9555 57.9803 29.3507 57.8293 28.7479 57.8887C28.1451 57.948 27.5813 58.214 27.1522 58.6415L13.2607 71V23.75C13.2607 22.3576 13.8139 21.0223 14.7984 20.0377C15.783 19.0531 17.1184 18.5 18.5107 18.5H81.5107Z",
    fill: "#1A75E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1448_1623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageThumbnailSvg);
export default __webpack_public_path__ + "static/media/ImageThumbnailSvg.7e59a6bcbe8733d59f58a2f76d936ddb.svg";
export { ForwardRef as ReactComponent };